/* =====================================================
   NZ SCROLL FX — Effets au scroll page d'accueil
   Un effet unique par rubrique
   ===================================================== */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  /* IntersectionObserver avec seuil 15% visible */
  function makeObserver(cb, threshold) {
    return new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) cb(e.target);
      });
    }, { threshold: threshold || 0.15, rootMargin: '0px 0px -40px 0px' });
  }

  /* Utilitaire : appliquer transition + etat initial */
  function init(el, styles) {
    Object.assign(el.style, { transition: 'none' });
    Object.assign(el.style, styles);
    el.style.transition = '';
  }

  /* ───────────────────────────────────────────────────
     1. SOUTIENS — logos en fondu cascade depuis le bas
     ─────────────────────────────────────────────────── */
  var soutiens = document.querySelector('.nz-soutiens, [class*="soutiens"]');
  if (soutiens) {
    var logos = soutiens.querySelectorAll('img, .nz-soutiens__logo, [class*="logo"]');
    logos.forEach(function (el) {
      el.style.cssText += ';opacity:0;transform:translateY(22px);transition:opacity 0.6s ease,transform 0.6s ease;';
    });
    var obs1 = makeObserver(function () {
      logos.forEach(function (el, i) {
        setTimeout(function () {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }, i * 80);
      });
      obs1.disconnect();
    });
    obs1.observe(soutiens);
  }

  /* ───────────────────────────────────────────────────
     2. PRESSE — slide depuis gauche/droite
     ─────────────────────────────────────────────────── */
  var press = document.querySelector('.nz-press, [class*="press"]');
  if (press) {
    var pressLeft = press.querySelector('.nz-press__text, .nz-press__content, [class*="press__text"], [class*="press__left"]');
    var pressRight = press.querySelector('.nz-press__image, .nz-press__visual, [class*="press__image"], [class*="press__right"]');
    if (pressLeft) pressLeft.style.cssText += ';opacity:0;transform:translateX(-40px);transition:opacity 0.7s ease,transform 0.7s ease;';
    if (pressRight) pressRight.style.cssText += ';opacity:0;transform:translateX(40px);transition:opacity 0.7s ease,transform 0.7s ease;';
    var obs2 = makeObserver(function () {
      if (pressLeft) { pressLeft.style.opacity = '1'; pressLeft.style.transform = 'translateX(0)'; }
      setTimeout(function () {
        if (pressRight) { pressRight.style.opacity = '1'; pressRight.style.transform = 'translateX(0)'; }
      }, 120);
      obs2.disconnect();
    });
    obs2.observe(press);
  }

  /* ───────────────────────────────────────────────────
     3. NOS INCONTOURNABLES — cartes montent en cascade
     ─────────────────────────────────────────────────── */
  var spotlight = document.querySelector('.nz-spotlight, [class*="spotlight"]');
  if (spotlight) {
    var spotHeader = spotlight.querySelector('.nz-spotlight__header, [class*="spotlight__header"]');
    var spotCards = spotlight.querySelectorAll('.nz-spotlight__card, [class*="spotlight__card"]');
    if (spotHeader) spotHeader.style.cssText += ';opacity:0;transform:translateY(30px);transition:opacity 0.7s ease,transform 0.7s ease;';
    spotCards.forEach(function (c) {
      c.style.cssText += ';opacity:0;transform:translateY(40px);transition:opacity 0.6s ease,transform 0.6s ease;';
    });
    var obs3 = makeObserver(function () {
      if (spotHeader) { spotHeader.style.opacity = '1'; spotHeader.style.transform = 'translateY(0)'; }
      spotCards.forEach(function (c, i) {
        setTimeout(function () {
          c.style.opacity = '1';
          c.style.transform = 'translateY(0)';
        }, 150 + i * 120);
      });
      obs3.disconnect();
    }, 0.1);
    obs3.observe(spotlight);
  }

  /* ───────────────────────────────────────────────────
     4. TOUS NOS PRODUITS — cartes fondu + montee douce
     ─────────────────────────────────────────────────── */
  var allProducts = document.querySelector('.nz-all-products, [class*="all-products"]');
  if (allProducts) {
    var apHeader = allProducts.querySelector('h2, .section__heading, [class*="heading"]');
    var apCards = allProducts.querySelectorAll('.card-wrapper, .product-card, [class*="card-wrapper"]');
    if (apHeader) apHeader.style.cssText += ';opacity:0;transform:translateY(24px);transition:opacity 0.65s ease,transform 0.65s ease;';
    apCards.forEach(function (c) {
      c.style.cssText += ';opacity:0;transform:translateY(30px);transition:opacity 0.55s ease,transform 0.55s ease;';
    });
    var obs4 = makeObserver(function () {
      if (apHeader) { apHeader.style.opacity = '1'; apHeader.style.transform = 'translateY(0)'; }
      apCards.forEach(function (c, i) {
        setTimeout(function () {
          c.style.opacity = '1';
          c.style.transform = 'translateY(0)';
        }, 100 + i * 70);
      });
      obs4.disconnect();
    }, 0.05);
    obs4.observe(allProducts);
  }

  /* ───────────────────────────────────────────────────
     5. EQUIPE — zoom doux depuis centre
     ─────────────────────────────────────────────────── */
  var team = document.querySelector('.nz-team, [class*="nz-team"]');
  if (team) {
    var teamHeader = team.querySelector('.nz-team__header, h2, [class*="team__title"]');
    var teamCards = team.querySelectorAll('.nz-team__card, .nz-team__member, [class*="team__card"], [class*="team__member"]');
    if (teamHeader) teamHeader.style.cssText += ';opacity:0;transform:scale(0.95) translateY(20px);transition:opacity 0.7s ease,transform 0.7s cubic-bezier(0.22,1,0.36,1);';
    teamCards.forEach(function (c) {
      c.style.cssText += ';opacity:0;transform:scale(0.92);transition:opacity 0.55s ease,transform 0.55s cubic-bezier(0.22,1,0.36,1);';
    });
    var obs5 = makeObserver(function () {
      if (teamHeader) { teamHeader.style.opacity = '1'; teamHeader.style.transform = 'scale(1) translateY(0)'; }
      teamCards.forEach(function (c, i) {
        setTimeout(function () {
          c.style.opacity = '1';
          c.style.transform = 'scale(1)';
        }, 100 + i * 80);
      });
      obs5.disconnect();
    }, 0.08);
    obs5.observe(team);
  }

  /* ───────────────────────────────────────────────────
     6. CARTE CADEAU — fondu + scale leger
     ─────────────────────────────────────────────────── */
  var gift = document.querySelector('.nz-gift-card, [class*="gift-card"], [class*="gift_card"]');
  if (gift) {
    gift.style.cssText += ';opacity:0;transform:scale(0.96) translateY(20px);transition:opacity 0.75s ease,transform 0.75s cubic-bezier(0.22,1,0.36,1);';
    var obs6 = makeObserver(function () {
      gift.style.opacity = '1';
      gift.style.transform = 'scale(1) translateY(0)';
      obs6.disconnect();
    });
    obs6.observe(gift);
  }

  /* ───────────────────────────────────────────────────
     7. BLOG — cartes slide depuis la gauche en cascade
     ─────────────────────────────────────────────────── */
  var blog = document.querySelector('.nz-blog-cards, [class*="blog-cards"], [class*="blog_cards"]');
  if (blog) {
    var blogHeader = blog.querySelector('h2, [class*="blog__title"], [class*="blog-cards__title"]');
    var blogCards = blog.querySelectorAll('[class*="blog__card"], [class*="blog-card"], article');
    if (blogHeader) blogHeader.style.cssText += ';opacity:0;transform:translateX(-30px);transition:opacity 0.65s ease,transform 0.65s ease;';
    blogCards.forEach(function (c, i) {
      c.style.cssText += ';opacity:0;transform:translateX(-' + (30 + i * 10) + 'px);transition:opacity 0.6s ease,transform 0.6s ease;';
    });
    var obs7 = makeObserver(function () {
      if (blogHeader) { blogHeader.style.opacity = '1'; blogHeader.style.transform = 'translateX(0)'; }
      blogCards.forEach(function (c, i) {
        setTimeout(function () {
          c.style.opacity = '1';
          c.style.transform = 'translateX(0)';
        }, 100 + i * 120);
      });
      obs7.disconnect();
    });
    obs7.observe(blog);
  }

  /* ───────────────────────────────────────────────────
     8. ENGAGEMENTS — icones en rebond depuis le bas
     ─────────────────────────────────────────────────── */
  var engagements = document.querySelector('.nz-engagements, [class*="engagements"]');
  if (engagements) {
    var engHeader = engagements.querySelector('h2, [class*="engagements__title"]');
    var engItems = engagements.querySelectorAll('[class*="engagements__item"], [class*="engagements__card"], [class*="engagement__item"]');
    if (engHeader) engHeader.style.cssText += ';opacity:0;transform:translateY(24px);transition:opacity 0.65s ease,transform 0.65s ease;';
    engItems.forEach(function (el) {
      el.style.cssText += ';opacity:0;transform:translateY(36px) scale(0.95);transition:opacity 0.6s ease,transform 0.6s cubic-bezier(0.34,1.56,0.64,1);';
    });
    var obs8 = makeObserver(function () {
      if (engHeader) { engHeader.style.opacity = '1'; engHeader.style.transform = 'translateY(0)'; }
      engItems.forEach(function (el, i) {
        setTimeout(function () {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0) scale(1)';
        }, 100 + i * 100);
      });
      obs8.disconnect();
    }, 0.1);
    obs8.observe(engagements);
  }

  /* ───────────────────────────────────────────────────
     9. AVIS — header slide droite, cartes fondu
     ─────────────────────────────────────────────────── */
  var reviews = document.querySelector('.nz-reviews, [class*="nz-reviews"]');
  if (reviews) {
    var revHeader = reviews.querySelector('.nz-reviews__header, [class*="reviews__header"]');
    if (revHeader) revHeader.style.cssText += ';opacity:0;transform:translateX(30px);transition:opacity 0.7s ease,transform 0.7s ease;';
    var obs9 = makeObserver(function () {
      if (revHeader) { revHeader.style.opacity = '1'; revHeader.style.transform = 'translateX(0)'; }
      obs9.disconnect();
    });
    obs9.observe(reviews);
  }

})();
